import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block text-center mb-3">* * *</p>
      
      <p class="poem-block mb-3">
        Холодно.<br/>
        И дует в окно.<br/>
        Только мне<br/>
        Уже всё равно.
      </p>
        
      <p class="poem-block mb-3">
        Больше нет<br/>
        Ни мыслей, ни чувств.<br/>
        Голос мой<br/>
        Молчит, мозг мой пуст.
      </p>
        
      <p class="poem-block mb-3">
        Развали-<br/>
        лась жизни стена.<br/>
        Без защит<br/>
        Стою я одна.
      </p>
        
      <p class="poem-block mb-3">
        И вокруг<br/>
        Сгущается мрак.<br/>
        Что же по-<br/>
        лучилось не так?
      </p>
        
      <p class="poem-block mb-3">
        Я стою<br/>
        На самом юру.<br/>
        Знать, пора <br/>
        Закончить игру. 
      </p>
        
      <p class="poem-block mb-3">
        Знаю, бу-<br/>
        дет радость и свет,<br/>
        Если я<br/>
        Скажу чуждому «нет!».
      </p>
        
      <p class="poem-block mb-3">
        И я говорю «нет»!
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: 'Холодно'
}
const itemDate = {
  rus: '11 октября 2022'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;